import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-24 md:w-24 lg:w-20 h-auto",
  id: "logo-img"
}, null, -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  class: "hidden w-full xl:block xl:w-auto items-center",
  id: "navbar-default"
}
const _hoisted_5 = { class: "font-medium flex flex-col p-4 xl:p-0 mt-4 xl:flex-row xl:space-x-8 xl:mt-0" }
const _hoisted_6 = { class: "block w-full absolute xl:hidden px-9 pb-4 bg-white/[.9] dark:bg-slate-900/[.8] backdrop-blur-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Bars2Icon = _resolveComponent("Bars2Icon")!
  const _component_XMarkIcon = _resolveComponent("XMarkIcon")!
  const _component_NavTransition = _resolveComponent("NavTransition")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(["block w-full sticky top-0 z-10 transition-all duration-300", { '-translate-y-full absolute': !_ctx.showNavbar }]),
    id: "navbar"
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex flex-wrap items-center justify-between px-9 md:py-4 bg-white/[.9] dark:bg-slate-900 backdrop-blur-sm transition-shadow duration-300", { 'shadow-lg dark:bg-slate-900/[.8]': !_ctx.hideNavShadow }])
    }, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dropDownActive = !_ctx.dropDownActive)),
        class: _normalizeClass(['inline-flex items-center p-2 ml-3 text-sm text-gray-500 xl:hidden transition-all motion-reduce:transition-none duration-500', _ctx.showTransition ? 'opacity-1 blur-0' : 'opacity-0 blur-sm'])
      }, [
        (!_ctx.dropDownActive)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_Bars2Icon, { class: "h-10 w-10 dark:fill-slate-300" })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_XMarkIcon, { class: "h-10 w-10 dark:fill-slate-300" })
            ]))
      ], 2),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", _hoisted_5, [
          _createElementVNode("li", {
            class: _normalizeClass(['transition-all motion-reduce:transition-none duration-500 delay-[50ms]', _ctx.showTransition ? 'translate-y-0 opacity-1' : '-translate-y-4 opacity-0'])
          }, [
            _createVNode(_component_router_link, {
              class: "block py-2 pl-3 pr-4 hover:text-link-color",
              to: "/"
            }, {
              default: _withCtx(() => [
                _createTextVNode("HOME")
              ]),
              _: 1
            })
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass(['transition-all motion-reduce:transition-none duration-500 delay-[100ms]', _ctx.showTransition ? 'translate-y-0 opacity-1' : '-translate-y-4 opacity-0'])
          }, [
            _createVNode(_component_router_link, {
              class: "block py-2 pl-3 pr-4 hover:text-link-color",
              to: "/servizi"
            }, {
              default: _withCtx(() => [
                _createTextVNode("SERVIZI")
              ]),
              _: 1
            })
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass(['transition-all motion-reduce:transition-none duration-500 delay-[150ms]', _ctx.showTransition ? 'translate-y-0 opacity-1' : '-translate-y-4 opacity-0'])
          }, [
            _createVNode(_component_router_link, {
              class: "block py-2 pl-3 pr-4 hover:text-link-color",
              to: "/chi-siamo"
            }, {
              default: _withCtx(() => [
                _createTextVNode("CHI SIAMO")
              ]),
              _: 1
            })
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass(['transition-all motion-reduce:transition-none duration-500 delay-[250ms]', _ctx.showTransition ? 'translate-y-0 opacity-1' : '-translate-y-4 opacity-0'])
          }, [
            _createVNode(_component_router_link, {
              class: "block py-2 pl-3 pr-4 hover:text-link-color",
              to: "/contattaci"
            }, {
              default: _withCtx(() => [
                _createTextVNode("📭 RICHIEDI UN PREVENTIVO ORA")
              ]),
              _: 1
            })
          ], 2)
        ])
      ])
    ], 2),
    _createVNode(_component_NavTransition, null, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_6, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                class: "block py-5 hover:text-link-color",
                to: "/"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("HOME")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                class: "block py-5 hover:text-link-color",
                to: "/servizi"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("SERVIZI")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                class: "block py-5 hover:text-link-color",
                to: "/chi-siamo"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("CHI SIAMO")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                class: "block py-5 hover:text-link-color",
                to: "/contattaci"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("CONTATTACI")
                ]),
                _: 1
              })
            ])
          ])
        ], 512), [
          [_vShow, _ctx.dropDownActive]
        ])
      ]),
      _: 1
    })
  ], 2))
}